import { AuthTranslationType } from "../../features/auth.types";

export const auth: AuthTranslationType = {
  auth: {
    cookieConsent: {
      title: "Cookie Consent",
      description: "This website uses cookies to enhance your browsing experience. By clicking 'Accept', you consent to the use of cookies in accordance with our Cookie Policy.",
      accept: "Accept Cookies",
      readMore: "To learn more, please read our ",
      privacyPolicy: "Privacy Policy",
      and: "and",
      termsOfService: "Terms of Service"
    },
    title: {
      resetPassword: "Reset Password",
      welcome: "Welcome Back"
    },
    form: {
      displayName: "Display Name",
      email: "Email",
      password: "Password",
      newPassword: "New Password",
      forgotPassword: "Forgot Password?",
      loading: "Loading...",
      signIn: "Sign In",
      signUp: "Sign Up",
      resetPassword: "Reset Password",
      sendResetLink: "Send Reset Link",
      alreadyHaveAccount: "Already have an account? Sign In",
      needAccount: "Need an account? Sign Up",
      backToSignIn: "Back to Sign In",
      orContinueWith: "Or continue with",
      google: "Google",
      facebook: "Facebook",
      privacyPolicyAgreement: "By clicking Sign Up, you agree to",
      privacyPolicy: "Privacy Policy",
      termsAgreement: "and",
      termsOfService: "Terms of Service"
    },
    toast: {
      missingInfo: {
        title: "Missing Information",
        description: "Please provide both email and password."
      },
      missingName: {
        title: "Missing Information",
        description: "Please provide a display name."
      },
      invalidEmail: {
        title: "Invalid Email",
        description: "Please enter a valid email address."
      },
      invalidPassword: {
        title: "Invalid Password",
        description: "Password must be at least 6 characters long."
      },
      emailNotVerified: {
        title: "Email Not Verified",
        description: "Please check your inbox and click the confirmation link to verify your email. Need a new link?",
        resend: "Resend"
      },
      verificationEmailSent: {
        title: "Verification Email Sent",
        description: "Please check your inbox for the confirmation link."
      },
      loginFailed: {
        title: "Login Failed",
        description: "Invalid email or password. Please try again or sign up if you don't have an account."
      },
      displayNameTaken: {
        title: "Display Name Taken",
        description: "This display name is already in use. Please choose another one."
      },
      signUpSuccess: {
        title: "Success",
        description: "Check your email for the confirmation link!"
      },
      userAlreadyRegistered: {
        title: "Sign Up Failed",
        description: "This email is already registered. Please try signing in instead."
      },
      resetEmailSent: {
        title: "Check your email",
        description: "We've sent you a password reset link. Please check your inbox."
      },
      resetSuccess: {
        title: "Success",
        description: "Your password has been reset successfully. Please sign in with your new password."
      },
      error: {
        title: "Error",
        description: "An unexpected error occurred. Please try again."
      },
      googleLoginError: {
        title: "Google Login Error",
        description: "Unable to sign in with Google. Please try again."
      },
      facebookLoginError: {
        title: "Facebook Login Error",
        description: "Unable to initiate Facebook login. Please try again."
      },
      samePassword: {
        title: "Same Password",
        description: "New password must be different from the old one."
      },
      agreementRequired: {
        title: "Agreement Required",
        description: "You must agree to the Privacy Policy and Terms of Service."
      },
    }
  }
};
